import { createAction, props } from '@ngrx/store';

// REST API / DB functions
export const fetchStats = createAction('[company] Fetch Stats');

export const setStats = createAction('[company] Set Stats', props<{ stats: any }>());
